module DBS.AutoComplete
{
    export interface IAutoCompleteOptions
    {
        postUrl: string;
        inputContainerId: string;
        inputElementId: string;
        errorElementId: string;
        submitElementId: string;
    }

    let autoItems: AutoCompleteWidget[] = [];
    const rateLimitDelay = 100;

    class AutoCompleteWidget
    {
        private readonly inputContainer: HTMLDivElement;
        private readonly inputElement: HTMLInputElement;
        private readonly errorElement: HTMLParagraphElement;
        private readonly submitElement: HTMLButtonElement;
        private readonly postUrl: string;

        private ajax: XMLHttpRequest | null = null;
        private timeout: number | null = null;

        private initiateSearch(ev: Event)
        {
            if (this.timeout != null)
            {
                clearTimeout(this.timeout);
            }

            if (this.ajax != null && this.ajax.readyState !== XMLHttpRequest.DONE)
            {
                this.ajax.abort();
            }

            this.timeout = setInterval(() => this.sendSearch(ev.target), rateLimitDelay);
        }

        private sendSearch(ctrl: EventTarget | null)
        {
            if (this.timeout != null)
            {
                clearTimeout(this.timeout);
            }

            if (ctrl == null)
            {
                return;
            }

            const inputCtrl = ctrl as HTMLInputElement;

            if (inputCtrl.value.length < 3)
            {
                const oldItems = this.inputContainer.getElementsByTagName("ul");

                for (let i = 0; i < oldItems.length; i++)
                {
                    oldItems[i].remove();
                }
                return;
            }

            this.ajax = new XMLHttpRequest();
            this.ajax.addEventListener("readystatechange", () => this.completeSearch());
            this.ajax.open("POST", this.postUrl, true);
            this.ajax.setRequestHeader("accept", "application/json");
            this.ajax.setRequestHeader("content-type", "application/x-www-form-urlencoded; charset=UTF-8");
            this.ajax.send(`=${encodeURIComponent(inputCtrl.value)}`);
        }

        private completeSearch()
        {
            if (this.ajax == null)
            {
                return;
            }

            if (this.ajax.readyState !== XMLHttpRequest.DONE || this.ajax.status !== 200)
            {
                return;
            }

            const items = JSON.parse(this.ajax.responseText) as string[];

            const oldItems = this.inputContainer.getElementsByTagName("ul");
            for (let i = 0; i < oldItems.length; i++)
            {
                oldItems[i].remove();
            }

            if (items.length === 0)
            {
                this.errorElement.classList.add("show");
                return;
            }

            this.errorElement.classList.remove("show");
            const autoList = document.createElement("ul") as HTMLUListElement;

            for (let i = 0; i < items.length; i++)
            {
                const listItem = document.createElement("li") as HTMLLIElement;
                listItem.innerText = items[i];
                listItem.addEventListener("click", (click) => this.selectSearch(click));
                autoList.appendChild(listItem);
            }

            this.inputContainer.appendChild(autoList);
        }

        private selectSearch(ev: Event)
        {
            const item = ev.target as HTMLLIElement;

            this.inputElement.value = item.innerText;

            const oldItems = this.inputContainer.getElementsByTagName("ul");
            for (let i = 0; i < oldItems.length; i++)
            {
                oldItems[i].remove();
            }

            this.submitElement.click();
        }

        constructor(options: IAutoCompleteOptions)
        {
            this.postUrl = options.postUrl;
            this.inputContainer = document.getElementById(options.inputContainerId) as HTMLDivElement;
            this.inputElement = document.getElementById(options.inputElementId) as HTMLInputElement;
            this.errorElement = document.getElementById(options.errorElementId) as HTMLParagraphElement;
            this.submitElement = document.getElementById(options.submitElementId) as HTMLButtonElement;

            this.inputElement.addEventListener("input", (ev) => this.initiateSearch(ev));
        }
    }

    export function SetupAutoComplete(options: IAutoCompleteOptions)
    {
        const item = new AutoCompleteWidget(options);
        autoItems.push(item);
    }
}